import { Component } from '@angular/core';

@Component({
  templateUrl: './pools.component.html',
  styleUrls: ['./pools.component.scss']
})
export class PoolsComponent {}
